"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1GetShoppingCart = void 0;
exports.v1GetShoppingCartSetMock = v1GetShoppingCartSetMock;
exports.v1GetShoppingCart = v1GetShoppingCart;
exports.useQueryV1GetShoppingCart = useQueryV1GetShoppingCart;
exports.useInfiniteQueryV1GetShoppingCart = useInfiniteQueryV1GetShoppingCart;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1GetShoppingCartSetMock(mock) {
    setMock = mock;
}
async function v1GetShoppingCart(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v1/checkout/onboarding/cart`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.countryCode = params.countryCode;
    queryParams.currency = params.currency;
    queryParams.state = params.state;
    queryParams.machineId = params.machineId;
    queryParams.postalCode = params.postalCode;
    queryParams.promoCode = params.promoCode;
    queryParams.useV2PromoCodes = params.useV2PromoCodes;
    queryParams.partnerId = params.partnerId;
    queryParams.userUniqueId = params.userUniqueId;
    queryParams.locale = params.locale;
    queryParams.requestingSource = params.requestingSource;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1GetShoppingCart = 'cockatoo:v1GetShoppingCart:get';
function useQueryV1GetShoppingCart(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetShoppingCart, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1GetShoppingCart(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetShoppingCart, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1GetShoppingCart(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-get-shopping-cart.js.map